import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/apps4all/Home.vue";
import Browse from "@/components/apps4all/Browse.vue";
import Profile from "@/components/apps4all/Profile.vue";
import HotPicks from "@/components/apps4all/HotPicks.vue";
import Popular from "@/components/apps4all/Popular.vue";
import Category from "@/components/apps4all/browse/Category.vue";
import Subcategory from "@/components/apps4all/browse/Subcategory.vue";
import DetailPage from "@/components/apps4all/DetailPage.vue";
import Login from "../components/authentication/apps4all/Login.vue";
import Contact from "../components/apps4all/Contact.vue";
import Feedback from "../components/apps4all/Feedback.vue";
import PrivacyPolicy from "../components/apps4all/PrivacyPolicy.vue";
import Terms from "../components/apps4all/Terms.vue";
import Unsubscription from "@/components/apps4all/Unsubscription.vue"
Vue.use(Router);

export default new Router({
  mode: "history",
  hash: false,
  history: true,
  routes: [
    {
      path: "/home",
      name: "Home",
      component: Home,
      children: [
        {
          path: "/home/:token"
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      children: [
        {
          path: "/logout"
        }
      ]
    },
    {
      path: "/unsubscription",
      name: "Unsubscription",
      component: Unsubscription
    },
    {
      path: "/browse",
      name: "Browse",
      component: Browse,
      children: [
        {
          path: "/browse/:token"
        }
      ]
    },
    {
      path: "/hotpicks",
      name: "HotPicks",
      component: HotPicks,
      children: [
        {
          path: "/hotpicks/:token"
        }
      ]
    },
    {
      path: "/popular",
      name: "Popular",
      component: Popular,
      children: [
        {
          path: "/popular/:token"
        }
      ]
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      children: [
        {
          path: "/contact/:token"
        }
      ]
    },
    {
      path: "/feedback",
      name: "Feedback",
      component: Feedback,
      children: [
        {
          path: "/feedback/:token"
        }
      ]
    },
    {
      path: "/privacy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
      children: [
        {
          path: "/privacy/:token"
        }
      ]
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms,
      children: [
        {
          path: "/terms/:token"
        }
      ]
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      children: [
        {
          path: "/profile/:token"
        }
      ]
    },
    {
      path: "/detail/:id",
      name: "DetailPage",
      component: DetailPage,
      children: [
        {
          path: "/detail/:id/:token"
        }
      ]
    },
    {
      path: "/subcategory/:category/:subcat",
      name: "Subcategory",
      component: Subcategory,
      children: [
        {
          path: "/subcategory/:category/:subcat/:token"
        }
      ]
    },
    {
      path: "/category/:category",
      name: "Category",
      component: Category,
      children: [
        {
          path: "/category/:category/:token"
        }
      ]
    },
    {
      path: '/:token',
      name: 'Home',
      component: Home
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/apps4all.js